// 配置表格 https://docs.google.com/spreadsheets/d/11YzMN4ANW0mZRs9yC_YTOma-ef9EVa-fsgUNd2MpImc/edit#gid=1577063460
const config = {
  // 注册	点击注册完成按钮上报
  register: {
    eventToken: "xszf3n",
    eventName: "registration",
    eventProperties: {
      adjust_id: "adid",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 完成注册	注册并登陆成功上报
  registerComplete: {
    eventToken: "7dyqh7",
    eventName: "registratio_completion",
    eventProperties: {
      adjust_id: "adid",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 商详访问 用户进入商品详情页
  productDetail: {
    eventToken: "bp1hcw",
    eventName: "view_item",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 订单创建	用户创建实体订单并且确认提交,当点击“创建“按钮时上报,
  createOrder: {
    eventToken: "x7baj0",
    eventName: "begin_checkout",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      uid: null,
      deviceId: "uuid",
    },
  },
  payNow: {
    eventToken: "pe23w7",
    eventName: "add_payment_info",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 分享	用户点击分享方式按钮上报
  productDetailShare: {
    eventToken: "haqnp1",
    eventName: "share",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 支付结果	支付结果页上报(不论结果成功or失败)
  payResult: {
    eventToken: "i0svem",
    eventName: "purchase",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      transaction_id: "订单id,唯一标识符",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 支付成功（真支付成功）	后端返回支付成功结果上报
  paySuccess: {
    eventToken: "rsrmja",
    eventName: "purchase_real",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      transaction_id: "订单id,唯一标识符",
      uid: null,
      deviceId: "uuid",
    },
  },
  // 填写个人资料	kyc填写资料页上报
  kycInfoSave: {
    eventToken: "3lgbrg",
    eventName: "kyc_apply_inform",
    eventProperties: {
      uid: null,
      deviceId: "uuid",
    },
  },
  // 分期下单	支付结果页上报
  installmentOrder: {
    eventToken: "c7c2d4",
    eventName: "purchase_installment",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      revenue: "商品售价,",
      item_id: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      transaction_id: "订单id,唯一标识符",
      uid: null,
      deviceId: "uuid",
    },
  },
};

export type AdjustConfigKey = keyof typeof config;

export default config;
